/** Cross-origin локальный dev (`npm start`) — Bearer JWT; prod/stage сборки — cookie-сессия. */
export const isBearerAuthMode = (): boolean => process.env.NODE_ENV === 'development';

export const getLoginUrl = (): string => (isBearerAuthMode() ? '/v1/Login' : '/v2/login');

export const getLogoutUrl = (): string =>
  isBearerAuthMode() ? '/v1/Login/logout' : '/v2/Login/logout';
